import React, { useState } from "react"
import { createRoot } from "react-dom/client"
import { Badge, Btn, Icon } from "./groupssuite/ui"

function buildUrl(basePath, filters, page) {
  const p = new URLSearchParams()
  if (filters.domain) p.set("domain", filters.domain)
  if (filters.q) p.set("q", filters.q)
  if (filters.titelbild) p.set("titelbild", "1")
  ;(filters.tags || []).forEach((t) => p.append("tags[]", t))
  if (page && page > 1) p.set("page", String(page))
  const s = p.toString()
  return s ? `${basePath}?${s}` : basePath
}

function Thumb({ src, alt }) {
  const [err, setErr] = useState(false)
  if (err || !src) {
    return (
      <div className="media-thumb media-thumb--placeholder">
        <Icon name="image" size={28} color="var(--ink-faint)" />
      </div>
    )
  }
  return (
    <img className="media-thumb" src={src} alt={alt || ""} loading="lazy" onError={() => setErr(true)} />
  )
}

function FilterBar({ basePath, labels, filters, options }) {
  return (
    <form className="media-filters" method="get" action={basePath}>
      <div className="media-filters__row">
        <div className="media-filters__search">
          <Icon name="search" size={15} color="var(--ink-faint)" />
          <input type="search" name="q" defaultValue={filters.q || ""} placeholder={labels.filters.search} className="media-filters__input" />
        </div>

        {options.showDomainFilter && (
          <select name="domain" defaultValue={filters.domain || ""} className="media-filters__select">
            <option value="">{labels.filters.all_domains}</option>
            {options.domains.map((d) => (
              <option key={d.id} value={d.id}>{d.name}</option>
            ))}
          </select>
        )}

        <label className="media-filters__toggle">
          <input type="checkbox" name="titelbild" value="1" defaultChecked={!!filters.titelbild} />
          {labels.filters.only_titelbild}
        </label>

        <Btn variant="accent">{labels.filters.apply}</Btn>
        <a href={basePath} className="media-filters__reset">{labels.filters.reset}</a>
      </div>

      {options.tags.length > 0 && (
        <div className="media-filters__tags">
          <span className="media-filters__tags-label">{labels.filters.tags}:</span>
          {options.tags.map((tag) => (
            <label key={tag} className={`tag-chip${(filters.tags || []).includes(tag) ? " is-on" : ""}`}>
              <input type="checkbox" name="tags[]" value={tag} defaultChecked={(filters.tags || []).includes(tag)} />
              {tag}
            </label>
          ))}
        </div>
      )}
    </form>
  )
}

function MediaIndex({ labels, basePath, total, pagination, filters, options, assets }) {
  const { page, totalPages } = pagination
  return (
    <section className="screen">
      <header className="screen__head">
        <div>
          <h1 className="screen__title">{labels.title}</h1>
          <p className="screen__subtitle">{labels.subtitle}</p>
        </div>
        <span className="media-count">{labels.results}</span>
      </header>

      <FilterBar basePath={basePath} labels={labels} filters={filters} options={options} />

      {assets.length === 0 ? (
        <p className="media-empty">{labels.empty}</p>
      ) : (
        <div className="media-grid">
          {assets.map((a) => (
            <a key={a.id} href={a.path} className="media-card">
              <div className="media-card__thumbwrap">
                <Thumb src={a.source_url} alt={a.title} />
                {a.titelbild && <span className="media-card__badge"><Badge tone="accent">{labels.titelbild_badge}</Badge></span>}
              </div>
              <div className="media-card__body">
                <div className="media-card__title">{a.title || "—"}</div>
                <div className="media-card__tags">
                  {(a.tags || []).filter((t) => t !== "titelbild").slice(0, 3).map((t) => (
                    <span key={t} className="tag-chip tag-chip--mini">{t}</span>
                  ))}
                </div>
              </div>
            </a>
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <nav className="media-pagination">
          {page > 1
            ? <a className="btn btn--ghost" href={buildUrl(basePath, filters, page - 1)}>← {labels.pagination.prev}</a>
            : <span className="btn btn--ghost is-disabled">← {labels.pagination.prev}</span>}
          <span className="media-pagination__info">{labels.pagination.page_of}</span>
          {page < totalPages
            ? <a className="btn btn--ghost" href={buildUrl(basePath, filters, page + 1)}>{labels.pagination.next} →</a>
            : <span className="btn btn--ghost is-disabled">{labels.pagination.next} →</span>}
        </nav>
      )}
    </section>
  )
}

function mount() {
  const el = document.getElementById("media-index")
  if (!el || el.dataset.mounted === "true") return
  let props = {}
  try {
    props = JSON.parse(el.dataset.props || "{}")
  } catch (error) {
    console.error("Invalid media-index props", error)
  }
  el.dataset.mounted = "true"
  createRoot(el).render(<MediaIndex {...props} />)
}

document.addEventListener("turbo:load", mount)
document.addEventListener("DOMContentLoaded", mount)
